import ApplicationController from "./application_controller";
import { animate } from 'animejs';


/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {

  static targets = ["sidebar", "toggler", "trigger",
    "toggleiconhidden", "toggleiconcollapsed", "toggleiconexpanded",
    "triggleiconhidden", "triggleiconcollapsed", "triggleiconexpanded"
  ];
  static values = {
    canhide: Boolean,
    sidebarState: { type: Number, default: 0 },
    sidebarHidden: { type: Number, default: 0},
    sidebarCollapsed: { type: Number, default: 1},
    sidebarExpanded: { type: Number, default: 2 },
  }

  connect() {
    if(this.canhideValue){
      this.addClickToExit();
    }
    if(this.hasTriggerTarget) {
      animate(this.triggerTarget, {
        duration: 500,
        easing: 'easeInOutQuad',
        rotate: '1turn'
      });
    }
    this.pageHeading = document.querySelector(".boards-header h1");

    this.sidebarTarget.classList.contains("expanded") ? this.expandSidebar() : null;
    this.sidebarTarget.classList.contains("collapsed") ? this.collapseSidebar() : null;
    this.sidebarTarget.classList.contains("d-none") ? this.hideSidebar() : null;
  }

  hideSidebar(event) {
    this.sidebarTarget.classList.remove("collapsed")
    this.sidebarTarget.classList.add("d-none");
    if(this.pageHeading) {
      this.pageHeading.classList.add("ms-5");
    }

    this.triggleiconhiddenTarget.classList.remove("d-none");
    this.triggleiconcollapsedTarget.classList.add("d-none");
    this.triggleiconexpandedTarget.classList.add("d-none");
    this.sidebarStateValue = 0;
  }

  toggleSidebar(event) {
    console.log("toggleSidebar: " + this.sidebarStateValue);
    event.preventDefault();
    event.stopPropagation();
    if (this.sidebarStateValue == this.sidebarExpandedValue) {
      this.sidebarStateValue = this.sidebarHiddenValue;
      this.hideSidebar(event);
    } else {
      this.sidebarStateValue = this.sidebarExpandedValue;
      this.expandSidebar(event);
    }
  }

  triggleSidebar(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.togglerTarget.offsetParent !== null) {
      return this.toggleSidebar(event);
    }

    console.log("icon target: " + this.iconcollapsedTarget);

    if (this.sidebarStateValue == this.sidebarExpandedValue) {
      this.sidebarStateValue = this.sidebarHiddenValue;
    } else {
      this.sidebarStateValue = this.sidebarStateValue + 1;
    }

    if (this.sidebarStateValue === this.sidebarCollapsedValue) {
      this.collapseSidebar(event);
    }
    if (this.sidebarStateValue === this.sidebarExpandedValue) {
      this.expandSidebar(event);
    }
    if (this.sidebarStateValue === this.sidebarHiddenValue) {
      this.hideSidebar(event);
    }
  }
  expandSidebar(event) {
    this.sidebarTarget.classList.remove("collapsed")
    this.sidebarTarget.classList.remove("d-none")
    // this.sidebarTarget.classList.add("animating")
    this.triggleiconhiddenTarget.classList.add("d-none");
    this.triggleiconcollapsedTarget.classList.add("d-none");
    this.triggleiconexpandedTarget.classList.remove("d-none");

    animate(this.sidebarTarget, {
      duration: 300,
      easing: 'easeOutQuad',
      width: ['0%', '100%']
    }).then(() => {
      this.sidebarTarget.classList.add("expanded");
      this.sidebarTarget.classList.remove("animating")
      this.sidebarStateValue = 2;
    });;

    // addClickToExit() - if you want to listen for clicks outside the sidebar
  }
  collapseSidebar(event) {
    this.sidebarTarget.classList.remove("d-none")
    this.sidebarTarget.classList.add("animating")

    this.triggleiconhiddenTarget.classList.add("d-none");
    this.triggleiconcollapsedTarget.classList.remove("d-none");
    this.triggleiconexpandedTarget.classList.add("d-none");

    animate(this.sidebarTarget, {
      duration: 100,
      easing: 'easeInQuad',
      width: ['0%', '3.0rem']
    }).then(() => {
      this.sidebarTarget.classList.add("collapsed");
      this.sidebarStateValue = 1;
      this.sidebarTarget.classList.remove("animating")
    });
  }
  addClickToExit() {
    document.addEventListener("click", (event) => {
      if (!this.sidebarStateValue == 0) return;
      if (!event.target.contains(this.sidebarTarget)) {
        this.collapseSidebar();
      }
    });
  }
}
